import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed, ref } from 'vue';
import { useQueryLoading } from '@vue/apollo-composable';
import { useGetImpactGoalQuery, useGetAccountQuery, Module } from '~/types/types';
import { useVentureId, resolveRequireImpactSubmission } from '~/functions/accounts';
import { buildImpactEditSections, buildImpactSections } from '~/functions/impact-navigation';
export default /*#__PURE__*/_defineComponent({
  __name: 'edit',
  setup: function setup(__props) {
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n;
    var ventureId = useVentureId();
    var _useGetImpactGoalQuer = useGetImpactGoalQuery({
        ventureId: ventureId.value
      }),
      result = _useGetImpactGoalQuer.result;
    var _useGetAccountQuery = useGetAccountQuery({
        id: ventureId.value
      }),
      ventureAccountResult = _useGetAccountQuery.result;
    var ventureAccount = computed(function () {
      var _ventureAccountResult;
      return (_ventureAccountResult = ventureAccountResult.value) === null || _ventureAccountResult === void 0 ? void 0 : _ventureAccountResult.getAccount;
    });
    var _useGetAccountQuery2 = useGetAccountQuery(),
      sessionAccountResult = _useGetAccountQuery2.result;
    var sessionAccount = computed(function () {
      var _sessionAccountResult;
      return (_sessionAccountResult = sessionAccountResult.value) === null || _sessionAccountResult === void 0 ? void 0 : _sessionAccountResult.getAccount;
    });
    var requireImpactSubmission = computed(function () {
      return resolveRequireImpactSubmission(sessionAccount.value, ventureAccount.value);
    });
    var hasImpactStrategyModule = computed(function () {
      var _ventureAccount$value, _ventureAccount$value2, _ventureAccount$value3;
      return (_ventureAccount$value = (_ventureAccount$value2 = ventureAccount.value) === null || _ventureAccount$value2 === void 0 ? void 0 : (_ventureAccount$value3 = _ventureAccount$value2.bookedModules) === null || _ventureAccount$value3 === void 0 ? void 0 : _ventureAccount$value3.includes(Module.ImpactStrategy)) !== null && _ventureAccount$value !== void 0 ? _ventureAccount$value : false;
    });
    var impactGoal = computed(function () {
      var _result$value;
      return ((_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getImpactGoal) || {};
    });
    var loading = useQueryLoading();
    var doGhgCheck = ref(true);
    var sections = computed(function () {
      return buildImpactEditSections({
        ventureId: ventureId.value,
        impactGoal: impactGoal.value,
        hasImpactStrategyModule: hasImpactStrategyModule.value,
        doGhgCheck: doGhgCheck.value,
        t: function t(key) {
          return $i18n.t(key);
        },
        requireImpactSubmission: requireImpactSubmission.value
      });
    });

    /** Used only for `v-if` guard on questionnaire flow (same shape as before). */
    var impactSections = computed(function () {
      return buildImpactSections(impactGoal.value, {
        ventureId: ventureId.value,
        doGhgCheck: doGhgCheck.value,
        t: function t(key) {
          return $i18n.t(key);
        },
        requireImpactSubmission: requireImpactSubmission.value
      });
    });
    return {
      __sfc: true,
      $i18n: $i18n,
      ventureId: ventureId,
      result: result,
      ventureAccountResult: ventureAccountResult,
      ventureAccount: ventureAccount,
      sessionAccountResult: sessionAccountResult,
      sessionAccount: sessionAccount,
      requireImpactSubmission: requireImpactSubmission,
      hasImpactStrategyModule: hasImpactStrategyModule,
      impactGoal: impactGoal,
      loading: loading,
      doGhgCheck: doGhgCheck,
      sections: sections,
      impactSections: impactSections
    };
  }
});